import React, { useState, useEffect, useRef } from "react";

import ChkBox from "components/Custom/ChkBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import { DEFAULTS } from "common/config";

const dataJson = require("components/Evaluation/ContractForm/gridData.json");

interface defaultProps {
  childRef: any;
  editRows: any[];
}

const Part2 = (props: defaultProps) => {
  const { childRef, editRows } = props;
  const [leadershipCols, setLeadershipCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      editable: false,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      editable: false,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: false,
      width: "20%",
    },
    {
      key: "score",
      name: "Score",
      editable: true,
      width: "5%",
      type: "dropdown",
      list: DEFAULTS.SCORES,
    },
  ]);

  let tmpLeadershipRows = dataJson["3"]["3.1"];
  let tmpInsurenceRows = dataJson["4"]["4.1"];
  for (let key in tmpLeadershipRows) {
    tmpLeadershipRows[key].checkBoxYes = "";
    tmpLeadershipRows[key].checkBoxNo = "";
    tmpLeadershipRows[key].score = "";
    tmpLeadershipRows[key].comments = "";
  }
  for (let key in tmpInsurenceRows) {
    tmpInsurenceRows[key].checkBoxYes = "";
    tmpInsurenceRows[key].checkBoxNo = "";
    tmpInsurenceRows[key].score = "";
    tmpInsurenceRows[key].comments = "";
  }

  if (!editRows) {
    tmpLeadershipRows = null;
    tmpInsurenceRows = null;
  } else if (editRows["records"]) {
    const safetyDetails = JSON.parse(
      editRows["records"][0]["leadershipDetails"]
    );
    for (let i = 0; i < tmpLeadershipRows.length; i++) {
      const jsonData = {
        question: tmpLeadershipRows[i].question,
        ...safetyDetails[i],
      };
      tmpLeadershipRows[i] = jsonData;
    }
    let safetyLen = tmpLeadershipRows.length;
    for (let i = 0; i < tmpInsurenceRows.length; i++) {
      const jsonData = {
        question: tmpInsurenceRows[i].question,
        ...safetyDetails[safetyLen + i],
      };
      tmpInsurenceRows[i] = jsonData;
    }
  }

  const [leadershipRows, setLeadershipRows] =
    useState<any[]>(tmpLeadershipRows);
  const [insurenceCols, setInsurenceCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      editable: false,
      width: "5%",
      renderCell: ({ insurenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={insurenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...insurenceRows,
                  check: !insurenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      editable: false,
      width: "5%",
      renderCell: ({ insurenceRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={insurenceRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...insurenceRows,
                  check: !insurenceRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: false,
      width: "20%",
    },
    {
      key: "score",
      name: "Score",
      type: "dropdown",
      list: DEFAULTS.SCORES,
      editable: true,
      width: "5%",
    },
  ]);
  const [insurenceRows, setInsurenceRows] = useState<any[]>(tmpInsurenceRows);

  const grid1Ref: any = useRef();
  const grid2Ref: any = useRef();

  useEffect(() => {
    childRef.saveRecord = saveRecord;
    return () => {
      childRef.saveRecord = null;
    };
  }, []);

  const saveRecord = () => {
    const section1 = grid1Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
        score: s1.score,
      };
    });
    const section2 = grid2Ref.getRowData().map((s1) => {
      return {
        id: s1.id,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        comments: s1.comments,
        score: s1.score,
      };
    });
    const items = [...section1, ...section2];
    return { items };
  };

  return (
    <>
      <h4 className="ehsHeading1">{dataJson["3"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["3"]["heading2"]}</h5>
      {tmpLeadershipRows ? (
        <ExcelGrid
          childRef={grid1Ref}
          cols={leadershipCols}
          rows={tmpLeadershipRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}

      <h4 className="ehsHeading1">{dataJson["4"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["4"]["heading2"]}</h5>
      {tmpInsurenceRows ? (
        <ExcelGrid
          childRef={grid2Ref}
          cols={insurenceCols}
          rows={tmpInsurenceRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
    </>
  );
};

export default Part2;
